import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {RmRateService} from '../../services/rm-rate.service';
import {RepublicaMovilService} from '../../services/republica-movil.service';
import {Router} from '@angular/router';
import {RmShoppingCartService} from '../../services/rm-shopping-cart.service';
import {orderType} from '../../../shared/constantes';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {RmRateInfoComponent} from '../rm-rate-info/rm-rate-info.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-rm-rates',
    templateUrl: './rm-rates.component.html',
    styleUrls: ['./rm-rates.component.css', '../../../../assets/css/rm-theme.css'],
    standalone: false
})
export class RmRatesComponent implements OnInit, OnDestroy {
    @Input() type = 'ftth';
    @Input() index = 0;

    public rateMaster: any;
    public rates = [];
    public rateFtth: any = null;
    public contractType = 'postpaid';
    public typeOrder: any = null;
    public loaded: boolean = false;
    // Provisional para que despues del 31 de agosto no se muestre la oferta
    public showOffer = false;
    private allSubscription: Subscription[] = [];

    constructor(
        private rateService: RmRateService,
        private rmService: RepublicaMovilService,
        private router: Router,
        private shoppingCartService: RmShoppingCartService,
        private modalService: NgbModal
    ) {
        // Provisional para que despues del 31 de agosto no se muestre la oferta
        const actualDate = new Date();
        const lastDayOffer = new Date(2020, 8, 1);

        if (actualDate <= lastDayOffer) {
            this.showOffer = true;
        }
    }

    ngOnInit(): void {
        this.allSubscription.push(this.rateService.getRates()
            .subscribe((data: any) => {
                if (data != null) {
                    this.rateMaster = data;
                    this.loaded = true;
                    this.getRateFtth();
                }
            })
        );

        this.allSubscription.push(this.rmService.getTypeOrder()
            .subscribe((data: any) => {
                this.typeOrder = data;
                this.getRateFtth();
            })
        );
    }

    getRateFtth() {
        if (this.rateMaster && this.typeOrder) {
            this.rmService.getRateFtth()
                .subscribe((data: any) => {
                    if (data != null && this.type === 'ftth_mobile') {
                        this.rateFtth = data;
                        this.rates = this.rateFtth.mobileRates;
                    } else {
                        this.rateFtth = null;
                        this.rates = [];
                        // las convergentes las queremos mostrar todas del tirón
                        if (this.rateMaster) {
                            if (this.typeOrder === orderType.CONVERGENT && this.type !== 'mobile') {
                                this.rates = [];
                                for (const rateFtth of this.rateMaster.ftth) {
                                    this.rates.push(rateFtth);
                                }
                            }
                        }
                    }
                });
        }
    }

    showFtthRate(index) {
        this.rates = [];

        setTimeout(() => {
            console.log(this.rateMaster.ftth[index]);
            this.rates.push(this.rateMaster.ftth[index]);
        });
    }

    showRates(type) {
        this.rates = [];
        this.contractType = type;

        setTimeout(() => {
            if (this.contractType === 'prepaid') {
                Array.prototype.push.apply(this.rates, this.rateMaster.mobile.pre.other);
                Array.prototype.push.apply(this.rates, this.rateMaster.mobile.pre.unlimited);
            } else {
                Array.prototype.push.apply(this.rates, this.rateMaster.mobile.post.other);
                Array.prototype.push.apply(this.rates, this.rateMaster.mobile.post.unlimited);

                if (this.rateMaster.additional && this.rateMaster.additional.post) {
                    Array.prototype.push.apply(this.rates, this.rateMaster.additional.post);
                }
            }
        });
    }

    priceWithIVA(amount): number {
        return amount * 1.21;
    }

    selectRate(rate: any) {
        rate.contractType = this.contractType;
        switch (this.type) {
            case 'ftth':
                this.rmService.setRateFtth(rate);
                this.shoppingCartService.getStepper().next();
                break;
            case 'ftth_mobile':
            case 'mobile':
                this.rmService.setRatesMobile(this.index, rate);
                break;
        }
    }

    switchToConvergent() {
        this.rmService.setTypeOrder('convergent');
        this.rmService.setPreventDestroy(true);
        this.router.navigate(['republica-movil/convergente']).then(() => {
            this.rmService.setPreventDestroy(false);
        });
    }

    selectPack(rateFtth, rateMobile) {
        rateFtth.contractType = this.contractType;
        rateMobile.contractType = this.contractType;
        this.rmService.setRateFtth(rateFtth);
        this.rmService.addFirstRatesMobile(rateMobile);
        this.shoppingCartService.getStepper().next();
    }

    modalMoreInfo(rate: any, subrate: any = null) {
        const modalRef = this.modalService.open(RmRateInfoComponent, {size: 'lg', centered: true});
        modalRef.componentInstance.rate = rate;
        modalRef.componentInstance.subrate = subrate;
    }

    openModalOffer(content) {
        this.modalService.open(content, {size: 'lg', centered: true});
    }

    ngOnDestroy() {
        if (this.allSubscription && this.allSubscription.length) {
            this.allSubscription.map(subs => subs.unsubscribe());
        }
    }
}
